<template>
  <div class="page">
    <c-source-detail
      :columns="columns"
      :data="data"
      resource="products"
    />

    <h3 style="margin-top: 30px;"> 颜色列表 </h3>
    <c-source-table
      :columns="ColorProductColumns"
      :table="{ data: this.data.color_products }"
    />
  </div>
</template>

<script>
import { Vue, Component } from 'vue-property-decorator';
import createColumns from './columns';

@Component
export default class ProductsShow extends Vue {
  data = {}

  get columns() {
    return createColumns({
      handleDeleted: () => this.$router.replace({ name: 'products.index' }),
      handleRefresh: this.fetchData,
      isDetail: true
    })
  }

  get ColorProductColumns() {
    return [
      {
        prop: 'id',
        label: '编号'
      },
      {
        prop: 'cover',
        label: '图片',
        renderCell: {
          type: 'image',
          objectFit: 'contain',
          width: '50px',
          height: 'auto'
        }
      },
      {
        prop: 'color',
        label: '颜色',
      },
      {
        prop: 'sale_price_range',
        label: '原价',
      },
      {
        prop: 'discount_price_range',
        label: '折扣价'
      },
      {
        prop: 'employee_price_range',
        label: '员工价'
      },
      {
        prop: 'commission_range',
        label: '佣金'
      },
      {
        prop: 'position',
        label: '权重',
      },
      {
        prop: 'view_count',
        label: '浏览量'
      },
      {
        prop: 'followers_count',
        label: '收藏人数',
      },
      {
        prop: 'initial_sale_count',
        label: '初始销量',
      },
      {
        prop: 'increase_factor',
        label: '增长系数'
      },
      {
        prop: 'real_sale_count',
        label: '实际销量',
      },
      {
        prop: 'published_at',
        label: '首次上架时间',
        renderCell: 'time',
        minWidth: 120
      }
    ]
  }

  mounted() {
    this.fetchData();
  }

  async fetchData() {
    this.data = await this.$request.get(`/products/${this.$route.params.id}`);
  }
}
</script>

<style lang="scss" scoped>
  /deep/ .trending-covers .cell{
    display: inline-flex;
    flex-wrap: wrap;
  }
</style>
